export { default as reducer } from './cart.ducks';



// WEBPACK FOOTER //
// ./src/routes/Cart/index.ts